<p-dialog
  [header]="title"
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '95%', 'max-width': '700px', 'max-height': 'calc(100vh - 10rem)' }"
  (onHide)="closeDialog()"
>
  <div class="info-container">
    <div class="label">Key</div>
    <div class="bordered-container rounded-sm">
      <div class="key-description">
        <div class="key success rounded"></div>
        <div class="description">FOS data</div>
      </div>
      <div class="key-description">
        <div class="key caution rounded"></div>
        <div class="description">FOS data pending</div>
      </div>
      <div class="key-description">
        <div class="key caution-text">PENDING/PNDG</div>
        <div class="description">Data pending</div>
      </div>
    </div>
    <div class="label">{{ infoType }}</div>
    <div class="bordered-container rounded-sm">
      @for (paragraph of hiDescription.paragraphs; track $index) {
      <div class="description width-100">{{ paragraph }}</div>
      }
    </div>
    <div class="label">Month Card Data</div>
    <div class="bordered-container rounded-sm">
      @for (paragraph of monthCardDataDescription.paragraphs; track $index) {
      <div class="description width-100">{{ paragraph }}</div>
      }
    </div>
  </div>
</p-dialog>
